export const CHECKOUT_ADDRESS_TIP_TEST_ID = 'checkout_address_tip';
export const BILLING_RADIO_BUTTONS_GROUP_NAME = 'BillingAddressRadioButtonsGroup';
export const BILLING_ADDRESS_ID = 'id-billing-address';
export var BillingOptions;
(function (BillingOptions) {
    BillingOptions["SAME_AS_SHIPPING_ADDRESS"] = "Same as shipping address";
    BillingOptions["USE_DIFFERENT_ADDRESS"] = "Use different address";
    BillingOptions["NONE"] = "None";
})(BillingOptions || (BillingOptions = {}));
export const LOCAL_STORAGE_BILLING_OPTION_KEY = 'Billing option';
